import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';
import withUseEffectErrorMessage from './withUseEffectErrorMessage';

const withColorPickerInput = (ColorPickerInputComponent) => {
   const WrappedComponent = (props) => {
      const {
         field: propsField,
         form: propsForm,
         ...restProps
      } = props;

      const onChangeNonEvent = useCallback((newInputValue) => {
         props.form.setFieldValue(props.field.name, newInputValue);
      }, []);

      return (
         <ColorPickerInputComponent
            { ...props.field }
            { ...restProps }
            onChangeNonEvent={ onChangeNonEvent }
         />
      );
   };

   WrappedComponent.propTypes = {
      field: PropTypes.shape({
         name: PropTypes.string.isRequired,
         onChange: PropTypes.func.isRequired,
         onBlur: PropTypes.func.isRequired,
         value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }).isRequired,
      form: PropTypes.shape({
         touched: PropTypes.objectOf(PropTypes.any).isRequired,
         errors: PropTypes.objectOf(PropTypes.any).isRequired,
         setFieldValue: PropTypes.func.isRequired,
      }).isRequired,
      isDisabled: PropTypes.bool,
   };

   WrappedComponent.defaultProps = {
      isDisabled: false,
   };

   return WrappedComponent;
};

const ColorPickerInput = (props) => {
   const [localValue, setLocalValue] = useState(props.value);
   const [isOpenPicker, setIsOpenPicker] = useState(false);

   const handleClick = useCallback(() => {
      setIsOpenPicker((prevState) => !prevState);
   }, []);

   const handleClose = useCallback(() => {
      setIsOpenPicker(false);
   }, []);

   const handleChange = useCallback((color) => {
      setLocalValue(color.hex);
   }, []);

   const handleChangeComplete = useCallback((color) => {
      props.onChangeNonEvent(color.hex);
      setLocalValue(color.hex);
   }, []);

   return (
      <div>
         <div
            onClick={ handleClick }
            style={{
               padding: '0.25rem',
               background: '#e9ecef',
               borderRadius: '4px',
               boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
               display: 'inline-block',
               cursor: 'pointer',
            }}
            aria-hidden='true'
         >
            <div
               style={{
                  width: '53px',
                  height: '21px',
                  borderRadius: '4px',
                  background: `${ props.value }`,
               } }
            />
         </div>
         {
            isOpenPicker
            && (
               <div
                  style={{
                     position: 'absolute',
                     zIndex: '2',
                  } }
               >
                  <div
                     style={{
                        position: 'fixed',
                        top: '0px',
                        right: '0px',
                        bottom: '0px',
                        left: '0px',
                     }}
                     onClick={ handleClose }
                     aria-hidden='true'
                  />
                  <SketchPicker
                     color={ localValue }
                     onChange={ handleChange }
                     onChangeComplete={handleChangeComplete}
                     disableAlpha
                  />
               </div>
            )
         }

      </div>
   );
};

ColorPickerInput.propTypes = {
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onChangeNonEvent: PropTypes.func.isRequired,
};

ColorPickerInput.defaultProps = {
   value: undefined,
};

export default withUseEffectErrorMessage(withColorPickerInput(ColorPickerInput));
